import Technologist from '@/models/Technologist';

export default class TechnologistRepository {
    public static getAll() {
        return Technologist.all();
    }

    public static getById(id: string) {
        return Technologist.query().whereId(id).withAll().first();
    }
}